import styled from "styled-components";

export interface TheadProps {
  hasBorderBottom?: boolean;
}

export const Thead = styled.div<TheadProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;

  padding-left: 24px;
  padding-right: 16px;

  border-bottom: 1px solid transparent;
  padding-bottom: 8px;

  ${({ hasBorderBottom }) =>
    hasBorderBottom &&
    `
      border-bottom-color: var(--mode-border-neutral-weakest);
  `};
`;
